import { toast } from "react-toastify";

const toastText = (message) => {
  if (typeof message === "string") return message.trim();
  if (message?.message) return String(message.message).trim();
  return "";
};

/** One visible toast per message. toast.isActive() matches the id, not the text. */
export function showErrorToast(message) {
  const text = toastText(message);
  if (!text || toast.isActive(text)) return;
  toast.error(text, { toastId: text });
}
